import React from 'react'
import s from './index.module.scss'
import { ReactComponent as ArrowIcon } from '../../../assets/icons/arrow-down.svg'
import classNames from 'classnames'
import useToggle from '../../../hooks/useToggle'

interface IProps {
	title: string
	children: React.ReactNode
}

const Accordion: React.FC<IProps> = ({ title, children }) => {
	const [isActive, toggle] = useToggle(false)

	return (
		<div className={s.accordion}>
			<div className={s.accordionTitle} onClick={toggle}>
				{title}
				<ArrowIcon className={classNames(s.accordionIcon, { [s.active]: isActive })} />
			</div>
			<div className={classNames(s.accordionBlock, { [s.active]: isActive })}>{children}</div>
		</div>
	)
}

export default Accordion
